import { getMathematicalOperatorOptions } from '../logicHelpers'
import { scoresInFlow, inputQuestionsInFlow } from '@rightmessage/flow-builder'

const scoreSource = () => {
  return {
    types: [
      { label: 'Lead Score', value: 'score' },
      { label: 'Variable', value: 'variable' },
      { label: 'Input Question', value: 'inputQuestion' }
      // {
      //   label: 'High Score',
      //   value: 'highScore'
      // },
      // {
      //   label: 'Low Score',
      //   value: 'lowScore'
      // }
    ],
    inputs: [
      {
        $formkit: 'autocomplete',
        key: 'scores-score',
        name: 'score',
        options: () => {
          const route = useRoute()
          const flowStore = useFlowStore()
          const questionStore = useQuestionStore()
          const offerFunnelId = Array.isArray(route.params.offerFunnelId)
            ? route.params.offerFunnelId[0]
            : route.params.offerFunnelId
          const flow = flowStore.getById(offerFunnelId)
          if (!flow) return []
          return scoresInFlow(
            flow.funnelDefinition,
            questionStore.questions
          ).map((score) => {
            return {
              label: score,
              value: score
            }
          })
        },
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'scores' && condition.$type === 'score'
      },
      {
        $formkit: 'select',
        key: 'scores-operator-select',
        id: 'operator',
        name: 'operator',
        options: getMathematicalOperatorOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'scores' && condition.$type === 'score'
      },
      {
        $formkit: 'text',
        key: 'scores-value-input',
        name: 'value',
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'scores' && condition.$type === 'score'
      },
      {
        $formkit: 'text',
        key: 'scores-variable-name',
        name: 'variableName',
        placeholder: 'last_offer_shown',
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'scores' && condition.$type === 'variable'
      },
      {
        $formkit: 'select',
        key: 'scores-variable-operator-select',
        id: 'operator',
        name: 'operator',
        options: getMathematicalOperatorOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'scores' && condition.$type === 'variable'
      },
      {
        $formkit: 'text',
        key: 'scores-variable-value-input',
        name: 'value',
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'scores' &&
          condition.$type === 'variable' &&
          condition.operator !== 'is_set' &&
          condition.operator !== 'is_not_set'
      },
      {
        $formkit: 'autocomplete',
        key: 'scores-input-question',
        name: 'questionId',
        options: () => {
          const route = useRoute()
          const flowStore = useFlowStore()
          const questionStore = useQuestionStore()
          const offerFunnelId = Array.isArray(route.params.offerFunnelId)
            ? route.params.offerFunnelId[0]
            : route.params.offerFunnelId
          const flow = flowStore.getById(offerFunnelId)
          if (!flow) return []
          return inputQuestionsInFlow(
            flow.funnelDefinition,
            questionStore.questions
          ).map((question) => {
            return {
              label: question.label,
              value: question.id
            }
          })
        },
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'scores' && condition.$type === 'inputQuestion'
      },
      {
        $formkit: 'select',
        key: 'scores-input-question-operator-select',
        id: 'operator',
        name: 'operator',
        options: getMathematicalOperatorOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'scores' && condition.$type === 'inputQuestion'
      },
      {
        $formkit: 'text',
        key: 'scores-input-question-value-input',
        name: 'value',
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'scores' &&
          condition.$type === 'inputQuestion' &&
          condition.operator !== 'is_set' &&
          condition.operator !== 'is_not_set'
      }
      // {
      //   $formkit: 'text',
      //   key: 'jsdata-variable-input',
      //   name: 'variable',
      //   placeholder: 'mydata.industry',
      //   can: (condition: { $source: string; $type: string }) =>
      //     condition.$source === 'jsdata'
      // },
      // {
      //   $formkit: 'select',
      //   key: 'jsdata-operator-select',
      //   id: 'operator',
      //   name: 'operator',
      //   options: getOperatorOptions(),
      //   can: (condition: { $source: string; $type: string }) =>
      //     condition.$source === 'jsdata'
      // },
      // {
      //   $formkit: 'text',
      //   key: 'jsdata-value-input',
      //   name: 'value',
      //   can: (condition: {
      //     $source: string
      //     $type: string
      //     operator: string
      //   }) =>
      //     condition.$source === 'jsdata' &&
      //     condition.operator !== 'is set' &&
      //     condition.operator !== 'is not set'
      // }
    ]
  }
}

export default scoreSource
